/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProductsInputs */

const en_nav_products = /** @type {(inputs: Nav_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

/**
* | output |
* | --- |
* | "Products" |
*
* @param {Nav_ProductsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_products = /** @type {((inputs?: Nav_ProductsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProductsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_products(inputs)
});